import { FormattedMessage } from 'react-intl';
import CustomState from '@rio-cloud/rio-uikit/CustomState';

type InvalidInvitationStateProps = {
    rejectionReason?: string;
    onClick: () => void;
};

const InvalidInvitationState = (props: InvalidInvitationStateProps) => {
    const { rejectionReason, onClick } = props;

    const message = rejectionReason?.includes('Duplicate') ? (
        <FormattedMessage id='intl-msg:network.invitation.invalidInvitation.duplicateEntryMessage' />
    ) : (
        <FormattedMessage id='intl-msg:network.invitation.invalidInvitation.defaultMessage' />
    );

    const title = rejectionReason?.includes('Duplicate') ? (
        <FormattedMessage id='intl-msg:network.invitation.invalidInvitation.duplicateEntryTitle' />
    ) : (
        <FormattedMessage id='intl-msg:network.invitation.invalidInvitation.defaultTitle' />
    );

    return (
        <CustomState
            outerClassName='shadow-default'
            headline={title}
            message={<div className='margin-top-25'>{message}</div>}
            icons={[
                {
                    name: 'rioglyph rioglyph-flash',
                    color: 'text-color-highlight',
                    className: 'text-size-300pct',
                },
            ]}
            buttons={[
                {
                    text: <FormattedMessage id='intl-msg:network.invitation.invalidInvitation.backToOverview' />,
                    onClick,
                },
            ]}
        />
    );
};

export default InvalidInvitationState;
